import ProjectItem from '../../../../../../components/Cards/CardComponents/ProjectItem'
import { Project } from '../../../../../../types/project'

interface ProjectSectionProps {
  projects: Project[]
}

export function ProjectSection({ projects }: ProjectSectionProps) {
  if (!projects?.length) return null

  return (
    <div className="tc-mv-question-field p-4 rounded-2xl text-white space-y-2">
      <h2 className="text-xl font-semibold">Projects</h2>
      <div className="space-y-8">
        {projects.map((project, index) => (
          <ProjectItem key={index} project={project} />
        ))}
      </div>
    </div>
  )
}
